import { useMemo, type CSSProperties } from "react";
import { Check } from "lucide-react";
import { getCategoryIcon, DEFAULT_CATEGORY_EMOJI } from "@/lib/categoryIcons";
import { cn } from "@/lib/cn";
import type { Category } from "@/api/types";
import styles from "./wizardSteps.module.css";

interface CategoryStepProps {
  categories: Category[];
  categoryId: string | null;
  onSelect: (id: string) => void;
}

export function CategoryStep({ categories, categoryId, onSelect }: CategoryStepProps) {
  // "Outros" é o catch-all - sempre faz mais sentido no fim da lista, não importa onde caia
  // alfabeticamente ou na ordem em que foi criada.
  const ordered = useMemo(
    () => [...categories].sort((a, b) => Number(a.name === "Outros") - Number(b.name === "Outros")),
    [categories]
  );

  return (
    <div className={styles.stepBlock}>
      <h3 className={styles.stepTitle}>Qual categoria?</h3>
      <div className={styles.categoryGrid}>
        {ordered.map((c) => {
          const Icon = getCategoryIcon(c.icon);
          const selected = categoryId === c.id;
          return (
            <button
              type="button"
              key={c.id}
              onClick={() => onSelect(c.id)}
              className={cn(styles.categoryItem, selected && styles.categoryItemSelected)}
              style={{ "--cat-color": c.color } as CSSProperties}
            >
              {selected && (
                <span className={styles.categoryCheck}>
                  <Check size={11} strokeWidth={3.5} />
                </span>
              )}
              <span className={styles.categoryGlyph}>
                {Icon ? <Icon size={22} strokeWidth={2.2} /> : c.icon || DEFAULT_CATEGORY_EMOJI}
              </span>
              <span className={styles.categoryName}>{c.name}</span>
            </button>
          );
        })}
        {categories.length === 0 && <p className={styles.emptyText}>Nenhuma categoria disponível.</p>}
      </div>
    </div>
  );
}
